// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul[data-v-72e69196]{display:-webkit-box;display:-ms-flexbox;display:flex;list-style-type:none;padding:0}li[data-v-72e69196]{margin:1px 0 5px 3px;font-family:DINPro;font-size:14px;font-weight:500;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:.2px;color:#777;text-transform:uppercase}.linked[data-v-72e69196]{cursor:pointer}.icon[data-v-72e69196]{width:24px;height:24px}", ""]);
// Exports
module.exports = exports;
